import React, { useRef } from "react";
import CopyIcon from "../icons/copyicon";
import Loader from "./../component/loader";
import AddFileIcon from "../icons/plusicon";
import DeletefileIcon from "../icons/DeletefileIcon";
export default function ImageOnlyUpload({ item, handleImage, size, value, image, iconDelete, insideOnchange, deleteImage, ImagePreLoader ,showDeleteIcon}) {
    const ref = useRef(null)
    return (
        <>
            <div className="media_image mb_0 absolute_loader relative">
                {ImagePreLoader
                    ? <Loader />
                    : <img src={value ? value : '/images/image-placeholder.png'} alt="image" />
                }
                <span className="upload_message">Upload PNG/JPEG of max size of {size}MB</span>
                <div className={`input_file ${showDeleteIcon ? 'active' : ''}`}>
                    <input
                        type="file"
                        ref={ref}
                        id={item}
                        style={{ display: "none" }}
                        onChange={handleImage}
                        accept={".png, .jpg, .jpeg"}
                    />
                    <span onClick={() => { ref.current.click(); }}>
                        <AddFileIcon />
                    </span>
                </div>
                {showDeleteIcon && iconDelete &&
                    <span className="remove_file pointer "
                        onClick={deleteImage}
                    ><DeletefileIcon /></span>
                }
            </div>
            <div className="field_row">
                <div className="field_input relative">
                    <input
                        type="text"
                        placeholder="https://cloudfront.aws.com/sdf2345"
                        name='inSite'
                        id={item}
                        value={image}
                        onChange={insideOnchange}
                    />
                    <span className="copy_box">
                        <CopyIcon />
                    </span>
                </div>
            </div>
        </>
    )
}
